import type { TrackingPageType } from '@/lib/tracking/services/tracking.eventTypes'
import type { FiltersFieldsFragment } from '@gql-generated/graphql'
import { ProductType } from '@gql-generated/graphql'

export function getTrackingPageProductType(product: {
  type: ProductType
  filters: FiltersFieldsFragment[]
}) {
  if (!product) return undefined

  const { type, filters } = product
  const isProduct = type === ProductType.Product
  const isMonoDiscriminant = isProduct && (filters?.length || 0) === 1

  let pageType: TrackingPageType
  if (isProduct && isMonoDiscriminant) pageType = 'fiche produit mono-discriminant'
  else if (isProduct && !isMonoDiscriminant) pageType = 'fiche produit multi-discriminant'
  else pageType = 'fiche article'

  return pageType
}
